import { render, staticRenderFns } from "./ItemsPage.vue?vue&type=template&id=00ded6b8"
import script from "./ItemsPage.vue?vue&type=script&lang=js"
export * from "./ItemsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports